import initReactApp from 'dpl/util/initReactApp';
import TipsSliderContainer from 'dpl/tell_your_tail/containers/TipsSliderContainer';

initReactApp({
  TipsSliderContainer
});
